import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  BUSINESS_CASH_MANAGEMENT_SOLUTION,
  BUSINESS_DEPOSIT,
  BUSINESS_FOREX_SERVICE,
  BUSINESS_INSURANCE,
  BUSINESS_INVESTMENT,
  BUSINESS_LOAN_SOLUTION,
  REQUEST_FOR_CALLBACK_DEPOSIT_PAGE,
  REQUEST_FOR_INVESTMENT_PAGE,
} from "routes/paths";
import { InitAutoLoanProvider } from "./Forms/AutoLoans/AutoLoanContext";
import AutoLoanForm from "./Forms/AutoLoans/AutoLoanForm";
import { InitCCProvider } from "./Forms/CreditCards/EWCCContext";
import EWCCForm from "./Forms/CreditCards/EWCCForm";
import { InitHomeLoanProvider } from "./Forms/HomeLoans/HomeLoanContext";
import HomeLoansForm from "./Forms/HomeLoans/HomeLoanForm";
import { InitPLProvider } from "./Forms/PersonalLoan/EWPLContext";
import EWPLForm from "./Forms/PersonalLoan/EWPLForm";
import LeadGenForm from "./LeadGen";
import TimeDepositForms from "./TimeDepositForms";

const styles = (theme) => ({
  applicationList: {
    "& span": {
      color: theme.palette.primary.main,
    },
  },
});

export default withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        applicationType: this.props.formtype,
      };
    }

    handleClick = (selectForm) => {
      this.setState({ applicationType: selectForm });
    };

    render() {
      const { classes, productType, handleClose, formval, displayType } =
        this.props;
      let showApplication = "";
      switch (this.state.applicationType) {
        case "creditcard":
          showApplication = (
            <InitCCProvider>
              <EWCCForm
                handleClose={handleClose}
                productType={productType}
                formval={formval}
                displayType={displayType}
              />
            </InitCCProvider>
          );
          break;
        case "personal-loan":
          showApplication = (
            <InitPLProvider>
              <EWPLForm handleClose={handleClose} displayType={displayType} />
            </InitPLProvider>
          );
          break;
        case "auto-loan":
          showApplication = (
            <InitAutoLoanProvider>
              <AutoLoanForm
                handleClose={handleClose}
                displayType={displayType}
              />
            </InitAutoLoanProvider>
          );
          break;
        case "home-loan":
          showApplication = (
            <InitHomeLoanProvider>
              <HomeLoansForm
                handleClose={handleClose}
                displayType={displayType}
              />
            </InitHomeLoanProvider>
          );
          break;
        case "leadgen":
          showApplication = <LeadGenForm handleClose={handleClose} />;
          break;
        case "timedeposit":
          showApplication = <TimeDepositForms handleClose={handleClose} />;
          break;
        default:
          showApplication = (
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
              <br />
              <Typography color="primary" variant="h5">
                Apply Today!
              </Typography>
              <Typography color="secondary" variant="h6">
                Please select an application type.
              </Typography>
              <List component="nav" className={classes.applicationList}>
                <a
                  href="https://www.ewbanker.com/secure/af_ewcc.asp"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <ListItem button>
                    <i className="far fa-credit-card icon24 icon-primary" />
                    <ListItemText primary="Credit Card" />
                  </ListItem>
                </a>

                <ListItem
                  button
                  onClick={() => this.handleClick("personal-loan")}
                >
                  <i className="flaticon-trader icon26 icon-primary" />
                  <ListItemText primary="Personal Loan" />
                </ListItem>
                <ListItem button onClick={() => this.handleClick("auto-loan")}>
                  <i className="flaticon-car icon24 icon-primary" />
                  <ListItemText primary="Auto Loan" />
                </ListItem>
                <ListItem button onClick={() => this.handleClick("home-loan")}>
                  <i className="flaticon-smart-house icon24 icon-primary" />
                  <ListItemText primary="Home Loan" />
                </ListItem>
              </List>

              <br />

              <Typography color="secondary" variant="h6">
                You may also apply for other EastWest products through call.
              </Typography>
              <List component="nav" className={classes.applicationList}>
                <ListItem
                  button
                  component={Link}
                  to={REQUEST_FOR_CALLBACK_DEPOSIT_PAGE}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Deposit" />
                </ListItem>

                <ListItem
                  button
                  component={Link}
                  to={REQUEST_FOR_INVESTMENT_PAGE}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Fixed Income" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to={`${BUSINESS_DEPOSIT}#request-for-callback`}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Business Deposit" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to={`${BUSINESS_CASH_MANAGEMENT_SOLUTION}#request-for-callback`}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Cash Management" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to={`${BUSINESS_LOAN_SOLUTION}#request-for-callback`}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Business Loans" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to={`${BUSINESS_INVESTMENT}#request-for-callback`}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Business Investments and Trust" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to={`${BUSINESS_FOREX_SERVICE}#request-for-callback`}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Business Forex Services" />
                </ListItem>
                <ListItem
                  button
                  component={Link}
                  to={`${BUSINESS_INSURANCE}#request-for-callback`}
                  target="blank"
                >
                  <i className="flaticon-phone-call icon30 icon-primary" />
                  <ListItemText primary="Call Back - Business Insurance" />
                </ListItem>
                {/* <a
                  href="https://www.ewbanker.com/callbackrequest/cashmanagement"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <ListItem button>
                    <i className="flaticon-phone-call icon30 icon-primary" />
                    <ListItemText primary="Call Back - Cash Management" />
                  </ListItem>
                </a> */}
              </List>
            </div>
          );
      }
      return <>{showApplication}</>;
    }
  }
);
